/* Native multipart submission preserves the file as a Shopify line item property. */
if (!customElements.get('be-artwork-upload')) {
  customElements.define('be-artwork-upload', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.closest('form');
      const input = this.querySelector('[data-artwork-file]');
      const preview = this.querySelector('[data-artwork-preview]');
      const image = this.querySelector('[data-artwork-image]');
      const name = this.querySelector('[data-artwork-name]');
      if (!form || !input) return;
      form.enctype = 'multipart/form-data';
      form.removeAttribute('novalidate');
      // These two forms own artwork properties. Retire the legacy app controls
      // only inside this form, including controls injected after page load.
      const clearLegacy = () => {
        form.querySelectorAll('gpo-container, gpo-hidden-inputs').forEach(node => node.remove());
      };
      clearLegacy();
      this.legacyObserver = new MutationObserver(clearLegacy);
      this.legacyObserver.observe(form, {childList: true, subtree: true});
      const update = () => {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
        const file = input.files[0];
        preview.hidden = !file;
        image.hidden = true;
        image.removeAttribute('src');
        name.textContent = file ? file.name : '';
        if (file && /^image\/(jpeg|png)$/.test(file.type)) {
          this.previewUrl = URL.createObjectURL(file);
          image.src = this.previewUrl;
          image.hidden = false;
        }
      };
      input.addEventListener('change', update);
      this.querySelector('[data-artwork-remove]').addEventListener('click', () => {
        input.value = '';
        update();
        input.focus();
      });
    }
    disconnectedCallback() {
      if (this.legacyObserver) this.legacyObserver.disconnect();
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    }
  });
}
